import React from 'react';
import { Link, useParams } from 'react-router-dom';
import DownloadButton from '../components/DownloadButton';
import { downloadCertificate, getCertificateById } from '../services/certificateService';

const Certificate: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const record = id ? getCertificateById(id) : undefined;

  if (!record) {
    return (
      <main className="page">
        <Link className="text-link" to="/">
          &larr; Back to finder
        </Link>
        <section className="section">
          <div className="empty-state">
            <h2>Certificate not found</h2>
            <p>Double-check the link or head back to the finder to upload and search again.</p>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="page">
      <Link className="text-link" to="/">
        &larr; Back to finder
      </Link>
      <section className="section">
        <div className="certificate-card">
          <div className="certificate-card__header">
            <h1>{record.fileName}</h1>
            <span className="certificate-card__badge">
              {new Date(record.uploadedAt).toLocaleString()}
            </span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(240px, 480px) 1fr', gap: 20 }}>
            <img
              src={record.previewUrl}
              alt={record.fileName}
              style={{ width: '100%', height: 'auto', borderRadius: 12, boxShadow: '0 8px 20px rgba(0,0,0,0.1)' }}
            />
            <div>
              <dl className="certificate-card__meta">
                <div>
                  <dt>Certificate ID</dt>
                  <dd>{record.id}</dd>
                </div>
                <div>
                  <dt>Type</dt>
                  <dd>{record.fileType}</dd>
                </div>
                <div>
                  <dt>Size</dt>
                  <dd>{Math.round(record.fileSize / 1024)} KB</dd>
                </div>
                <div>
                  <dt>OCR Pages</dt>
                  <dd>{record.pages.length}</dd>
                </div>
              </dl>
              <div style={{ whiteSpace: 'pre-wrap', background: '#f8fafc', padding: 12, borderRadius: 8, color: '#334155' }}>
                {record.fullText.slice(0, 800)}{record.fullText.length > 800 ? '…' : ''}
              </div>
            </div>
          </div>
          <div className="certificate-card__actions">
            <DownloadButton certificateId={record.id} onDownload={downloadCertificate} />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Certificate;
